import { useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InstagramRedirectPage() {
  useEffect(() => {
    let cancelled = false;

    const openSite = () => {
      if (cancelled) return;
      const target = new URL("/", window.location.origin);
      target.searchParams.set("utm_source", "instagram");
      target.searchParams.set("utm_medium", "bio");
      target.searchParams.set("utm_campaign", "profile_link");
      window.location.replace(target.toString());
    };

    const trackAndRedirect = async () => {
      const payload = {
        source: "instagram",
        campaign: "bio",
        path: `${window.location.pathname}${window.location.search}`,
        referrer: document.referrer || "",
        language: navigator.language || "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        screen: window.screen ? `${window.screen.width}x${window.screen.height}` : "",
      };

      await axios.post(`${API}/track/instagram-bio`, payload).catch(() => {});
      openSite();
    };

    const timer = window.setTimeout(trackAndRedirect, 300);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <main className="min-h-screen bg-[#FAF3E0] text-[#3D1F00] velora-grain flex items-center justify-center px-6">
      <motion.section
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="w-full max-w-sm border border-[#E0D4B6] bg-white/70 backdrop-blur-sm p-8 text-center"
      >
        <div className="mx-auto mb-5 h-14 w-14 rounded-full border border-[#E8943A]/50 bg-[#111832] flex items-center justify-center">
          <img
            src="/logo.png"
            alt="Vilora Impex"
            className="h-10 w-10 object-contain"
            style={{ filter: "drop-shadow(0 0 14px rgba(232,148,58,0.55))" }}
          />
        </div>
        <div className="velora-micro text-[#7B3F00] mb-3">Instagram Visit</div>
        <h1 className="velora-serif text-4xl leading-none tracking-tight">
          Opening Vilora Impex
        </h1>
        <div className="mt-7 h-1.5 w-full overflow-hidden bg-[#E0D4B6]/70">
          <motion.div
            className="h-full bg-[#E8943A]"
            initial={{ x: "-100%" }}
            animate={{ x: "100%" }}
            transition={{ repeat: Infinity, duration: 1.1, ease: "easeInOut" }}
          />
        </div>
      </motion.section>
    </main>
  );
}
